import { gql } from "@apollo/client";

const AvailableDevicesSubscription = gql`
  subscription AvailableDevices {
    listen(topic: "device_update") {
      query {
        allDevices(condition: { isActive: true }, orderBy: DEVICE_NAME_ASC) {
          nodes {
            id
            latitudeField
            longitudeField
            altitudeField
            orientedImageryType
            headingField
            timeField
            timestampFormat
            deviceName
            fileFormat
            isActive
            dateTimeField
            dateField
          }
        }
      }
    }
  }
`;

const hash = "bbbd7389cc02a31b158cf1d4bf957f76408144be6e08847222458d20c31076d6";

export { AvailableDevicesSubscription, hash };
